import { createUseStyles } from 'react-jss';

import colors from "../../../utils/colors";

var styles = {
  proposalCard: {
    display: 'grid',
    gridTemplateColumns: '1fr 2.4rem',
    gap: '0.5rem',
    paddingBottom: '1.5rem',
    borderBottom: "0.1rem solid ".concat(colors.neutral[300]),
    marginBottom: '1.5rem'
  },
  titleWrapper: {
    fontSize: '1.4rem',
    lineHeight: '2rem',
    margin: '0 0 0.5rem 0'
  },
  productTitle: function productTitle(versionsCount) {return {
      letterSpacing: '0.02em',
      color: colors.neutral[900],
      marginRight: versionsCount > 1 ? '1rem' : '0'
    };},
  versionsCount: {
    color: colors.green[600],
    whiteSpace: 'nowrap'
  },
  removeButton: {
    height: '2.4rem'
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map